/**
 * Claims accepted by the API for `wo-order-task-types`
 * (`WoOrderTaskTypesController`). The legacy `WFM-ACTIVITY-TYPES-*` codes exist
 * only in the frontend — they are kept here so already-issued profiles keep
 * working, but the API-side codes are the canonical ones.
 */
export const ACTIVITY_TYPE_READ_CLAIMS = ['WO-ORDER-TASK-TYPES-R', 'WO-CONFIG-R', 'WFM-ACTIVITY-TYPES-R'];

export const ACTIVITY_TYPE_WRITE_CLAIMS = ['WO-ORDER-TASK-TYPES-W', 'WO-CONFIG-W', 'WFM-ACTIVITY-TYPES-W'];
